import { gql } from "@apollo/client";

import { SUBACCOUNT_ADMIN_FIELDS } from "./subaccounts";

export const RESPONSE_SCRIPT_FIELDS = gql`
  fragment FieldsForResponseScript on ResponseScript {
    id
    title
    script
    mediaUpload {
      id
      fileName
      publicGetUrl
      contentType
    }
    tags {
      id
      name
      group {
        id
        name
      }
    }
    keywords {
      id
      createdAt
      updatedAt
      normalizedKeyword
    }
    createdAt
    updatedAt
    sourceSheetId
  }
`;

export const RESPONSE_SCRIPT_GROUP_FIELDS = gql`
  ${RESPONSE_SCRIPT_FIELDS}
  fragment FieldsForResponseScriptGroup on ResponseScriptGroup {
    id
    title
    sortOrder
    includeInCampaignByDefault
    createdAt
    updatedAt
    memberships {
      id
      script {
        ...FieldsForResponseScript
      }
      sortOrder
    }
  }
`;

export const LIST_RESPONSE_SCRIPT_GROUPS = gql`
  ${RESPONSE_SCRIPT_GROUP_FIELDS}
  query ListResponseScripts($input: ListResponseScriptsInput!) {
    listResponseScripts(input: $input) {
      ...FieldsForResponseScriptGroup
    }
  }
`;

export const CREATE_RESPONSE_SCRIPT_GROUP = gql`
  ${RESPONSE_SCRIPT_GROUP_FIELDS}
  mutation CreateResponseScriptGroup($input: CreateResponseScriptGroupInput!) {
    createResponseScriptGroup(input: $input) {
      ...FieldsForResponseScriptGroup
    }
  }
`;

export const EDIT_RESPONSE_SCRIPT_GROUP = gql`
  ${RESPONSE_SCRIPT_GROUP_FIELDS}
  mutation EditResponseScriptGroup($input: EditResponseScriptGroupInput!) {
    editResponseScriptGroup(input: $input) {
      ...FieldsForResponseScriptGroup
    }
  }
`;

export const REORDER_RESPONSE_SCRIPT_GROUP = gql`
  mutation ReorderResponseScriptGroup(
    $input: ReorderResponseScriptGroupInput!
  ) {
    reorderResponseScriptGroup(input: $input)
  }
`;

export const DELETE_RESPONSE_SCRIPT_GROUP = gql`
  mutation DeleteResponseScriptGroup($input: DeleteResponseScriptGroupInput!) {
    deleteResponseScriptGroup(input: $input)
  }
`;

export const CREATE_RESPONSE_SCRIPT = gql`
  ${RESPONSE_SCRIPT_FIELDS}
  mutation CreateResponseScript($input: CreateResponseScriptInput!) {
    createResponseScript(input: $input) {
      ...FieldsForResponseScript
    }
  }
`;

export const EDIT_RESPONSE_SCRIPT = gql`
  ${RESPONSE_SCRIPT_FIELDS}
  mutation EditResponseScript($input: EditResponseScriptInput!) {
    editResponseScript(input: $input) {
      ...FieldsForResponseScript
    }
  }
`;

export const DELETE_RESPONSE_SCRIPT = gql`
  mutation DeleteResponseScript($input: DeleteResponseScriptInput!) {
    deleteResponseScript(input: $input)
  }
`;

export const REORDER_RESPONSE_SCRIPT_MEMBERSHIP = gql`
  mutation ReorderResponseScriptMembership(
    $input: ReorderResponseScriptMembershipInput!
  ) {
    reorderResponseScriptMembership(input: $input)
  }
`;

export const IMPORT_RESPONSE_SCRIPTS = gql`
  mutation importResponseScripts($input: ImportResponseScriptsInput!) {
    importResponseScripts(input: $input)
  }
`;

export const GET_CAMPAIGN_PERSONALIZED_GIF_PREVIEW = gql`
  query GetCampaignPersonalizedGifPreview(
    $input: GetCampaignPersonalizedGifPreviewLinkInput!
  ) {
    getCampaignPersonalizedGifPreviewLink(input: $input) {
      gifUrl
      pngUrl
    }
  }
`;

export const IMPORT_EXTERNAL_RESPONSE_SCRIPTS = gql`
  ${SUBACCOUNT_ADMIN_FIELDS}
  mutation ImportExternalResponseScripts(
    $input: ImportExternalResponseScriptsInput!
  ) {
    importExternalResponseScripts(input: $input) {
      ... on Subaccount {
        ...SubaccountAdminFields
      }
      ... on Campaign {
        id
        responseScriptImportToCampaignJob {
          id
          status
          result {
            errors {
              msg
              row
            }
            nGroupsCreated
            nRows
            nScriptsImported
          }
          errorMessage
        }
      }
    }
  }
`;
